import { render, staticRenderFns } from "./phoneModal.vue?vue&type=template&id=fbc46c08&scoped=true&"
import script from "./phoneModal.vue?vue&type=script&lang=js&"
export * from "./phoneModal.vue?vue&type=script&lang=js&"
import style0 from "./phoneModal.vue?vue&type=style&index=0&id=fbc46c08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc46c08",
  null
  
)

export default component.exports